import _ from 'lodash';
import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';

import { IconComponent as Icon } from 'components/icon';

import file from 'static/icons/svg/file.svg';
import styles from './download-component.styles.scss';


export class DownloadComponent extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    className: PropTypes.string,
  }

  render() {
    const { className, src } = this.props;
    const classname = classnames(styles.Download, className);
    const documentName = _.last(src.split('/')).replace(/\.[^.]+/, '');

    return (
      <a href={src} className={classname} target='_blank' rel='noopener noreferrer'>
        <Icon src={file} className={styles.Icon} />
        <span className={styles.Text}>{ documentName }</span>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/download/download.component.jsx